import React from "react";
import {
  Stack,
  IconButton,
  Button,
  Typography,
  Box,
  Tooltip,
  CircularProgress,
} from "@mui/material";
import ArrowHorizontal from "@/assets/svg/ArrowHorizontal";
import QuestionCircleSvg from "@/assets/svg/QuestionCircleSvg";
import { stylesLongPostHeader as style } from "./stylesLongPostHeader";
import theme from "@/theme";

const LongPostHeader: React.FC<any> = ({
  handleClose,
  handlePublish,
  setPreview,
  checkDisabled,
  preview,
  isEdit = false,
  isPublished,
  isPaidContent,
  invalidPrice,
  invalidCashtags,
  isSubmitting = false,
  scrolled,
  hasChanges = true,
  showHowToPublish = false,
  onShowPublishRequirements,
}) => {
  const disabled = checkDisabled() || isSubmitting;
  const priceInvalidForAction = isPaidContent && invalidPrice;
  const isPublishDisabled = disabled || priceInvalidForAction;
  const isSaveChangesDisabled =
    disabled || (isEdit && priceInvalidForAction) || (isEdit && !hasChanges);
  const submitSpinner = isSubmitting ? (
    <CircularProgress size={16} sx={{ color: "inherit" }} />
  ) : null;
  const priceTooltipText = "Please enter a valid price to publish paid content.";

  return (
    <>
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        sx={style.container(preview, scrolled)}
      >
        <IconButton
          onClick={() => {
            if (preview) {
              setPreview(false);
            } else if (isEdit) {
              handleClose();
            } else {
              handlePublish(isPublished);
              handleClose();
            }
          }}
          size="small"
          sx={style.backButton}
        >
          <ArrowHorizontal style={style.arrowIcon} />
        </IconButton>

        {!preview && (
          <Button
            sx={{
              marginLeft: "24px",
              width: 72,
              height: 28,
              color: "#52575D",
              border: "1px solid #E4E7E9",
              borderRadius: 2,
              paddingTop: "4px",
              paddingRight: "8px",
              paddingBottom: "4px",
              paddingLeft: "2px",
              fontFamily: "Inter, sans-serif",
              fontWeight: 500,
              fontStyle: "normal",
              fontSize: 14,
              lineHeight: "20px",
              letterSpacing: "0%",
              textAlign: "center",
              textTransform: "none",
            }}
          >
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "20px",
                height: "20px",
              }}
            >
              <Box
                sx={{
                  width: "6px",
                  height: "6px",
                  background: "#008001",

                  borderRadius: "50%",
                }}
              />
            </Box>
            Saved
          </Button>
        )}
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="center"
          sx={style.MessageWrapper}
        >
          {invalidCashtags && invalidCashtags.length > 0 ? (
            <Typography
              sx={{
                fontFamily: "Inter",
                fontWeight: 500,
                fontSize: "13px",
                lineHeight: "16px",
                color: theme.palette.error.main,
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              Invalid cashtag{invalidCashtags.length > 1 ? "s" : ""}: {invalidCashtags.join(", ")}
            </Typography>
          ) : preview ? (
            <Typography sx={style.centerTextPreview(preview, isEdit)}>Preview</Typography>
          ) : isEdit ? (
            <Typography sx={style.centerTextPreview(preview, isEdit)}>Edit article</Typography>
          ) : (
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
              }}
            ></Box>
          )}
        </Stack>

        {isEdit && preview ? (
          <Tooltip
            title={isEdit && priceInvalidForAction ? priceTooltipText : ""}
            disableHoverListener={!(isEdit && priceInvalidForAction)}
          >
            <span>
              <Button
                onClick={() => handlePublish(isPublished)}
                variant="contained"
                sx={style.SaveChanges(isSaveChangesDisabled)}
                disabled={isSaveChangesDisabled}
              >
                {isSubmitting ? submitSpinner : "Save changes"}
              </Button>
            </span>
          </Tooltip>
        ) : (
          <Stack direction="row" alignItems="center" gap="7px">
            {!preview && showHowToPublish && (
              <Button
                startIcon={<QuestionCircleSvg width={24} height={24} />}
                onClick={onShowPublishRequirements}
                variant="text"
                color="primary"
                sx={style.howToPublishButton}
              >
                How to publish?
              </Button>
            )}
            {preview ? (
              <Button
                onClick={() => {
                  handlePublish(false);
                }}
                variant="text"
                sx={style.previewButtonSave}
                disabled={disabled}
              >
                {isSubmitting ? submitSpinner : "Save as draft"}
              </Button>
            ) : (
              <Button
                onClick={() => {
                  setPreview(true);
                }}
                variant="text"
                sx={style.previewButton}
                disabled={disabled}
              >
                Preview
              </Button>
            )}
            {isEdit ? (
              <Tooltip
                title={isEdit && priceInvalidForAction ? priceTooltipText : ""}
                disableHoverListener={!(isEdit && priceInvalidForAction)}
              >
                <span>
                  <Button
                    onClick={() => handlePublish(isPublished)}
                    variant="contained"
                    sx={style.SaveChanges(isSaveChangesDisabled)}
                    disabled={isSaveChangesDisabled}
                  >
                    {isSubmitting ? submitSpinner : "Save changes"}
                  </Button>
                </span>
              </Tooltip>
            ) : (
              <Tooltip
                title={priceInvalidForAction ? priceTooltipText : ""}
                disableHoverListener={!priceInvalidForAction}
              >
                <span>
                  <Button
                    onClick={() => handlePublish(true)}
                    variant="contained"
                    sx={style.publishButton(isPublishDisabled)}
                    disabled={isPublishDisabled}
                  >
                    {isSubmitting ? submitSpinner : "Publish"}
                  </Button>
                </span>
              </Tooltip>
            )}
          </Stack>
        )}
      </Stack>
    </>
  );
};

export default LongPostHeader;
